import UIkit from 'uikit';

export default {
  init() {
    // JavaScript to be fired on all pages

    //Attach UIkit to window
    window.UIkit = UIkit;
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    
    //MailChimp Forms
    $('#mc_embed_signup input[type=text], #mc_embed_signup input[type=email]').on('change keyup paste propertychange', function () {
      if ($(this).val() !== '') {
        $(this).parent().addClass('has-value');
      } else {
        $(this).parent().removeClass('has-value');
      }
    });
    
    //Ninja Forms
    $(document).on('nfFormReady', function () {
      // console.log('Form is ready');
      $('.nf-form-cont input[type=text], .nf-form-cont input[type=email], .nf-form-cont textarea').on('change keyup paste propertychange', function () {
        if ($(this).val() !== '') {
          $(this).parent().parent().addClass('has-value');
        } else {
          $(this).parent().parent().removeClass('has-value');
        }
      });
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js